import axios from "axios";
import config from '../../config'

// const BASE_URL = "http://3.22.188.65:8080"
const BASE_URL = config.apiUrl;

const GetlisteNews = async () => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }

    const instance = axios.create(options);

    try {
        const response = await instance.get("/rabat-zoo/news/api/all");

        // Filtrer les données pour exclure celles qui sont disabled ou hide
        const filteredNews = response.data.filter(news => !news.disable && !news.hide);

        return filteredNews;
    } catch (error) {
        throw error.response;
    }
}


const AddNews = async (DataPost) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin': "*/*",
            //'Authorization': `Bearer ${Token}`
        },
    }

    const instance = axios.create(options);

    try {
        const response = await instance.post("/rabat-zoo/news/api/add", DataPost);
        console.log('AddNews response:', response.data);
        return response;
    } catch (error) {
        console.error('AddNews error:', error);
        throw error.response || error;
    }

}

const UploadImgNew = async (formData) => {
    const options = {
        baseURL: BASE_URL,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }

    const instance = axios.create(options);
    try {
        const response = await instance.post("/rabat-zoo/news/api/upload", formData);
        console.log('Upload successful:', response.data);
        return response.data;
    } catch (error) {
        console.error('Upload image error:', error.response || error);
        throw error.response || error;
    }
};


// Fonction pour supprimer une actualité par son ID
const DeleteNews = async (id) => {
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            // 'Authorization': `Bearer ${Token}`  // Décommentez si vous utilisez un token
        },
    };

    const instance = axios.create(options);

    try {
        // Appel de l'API pour supprimer la news
        const deleteResponse = await instance.delete(`/rabat-zoo/news/api/delete/${id}`);
        return deleteResponse.data; // Retourne la réponse de l'API
    } catch (error) {
        console.error("Erreur de suppression dans DeleteNews:", error);  // Affiche les détails de l'erreur
        throw error.response || error.message;  // Retourne l'erreur
    }
};


const UpdateNews = async (DataPost) => {
  const options = {
      baseURL: BASE_URL,
      responseType: 'json',
      headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          'Access-Control-Allow-Origin': "*/*",
          // 'Authorization': `Bearer ${Token}`
      },
  };

  const instance = axios.create(options);

  try {
      const response = await instance.post("/rabat-zoo/news/api/update", DataPost);
      return response;  // Données mises à jour de l'actualité
  } catch (error) {
      throw error.response;
  }
};




export { GetlisteNews, AddNews, UploadImgNew, DeleteNews, UpdateNews };
